import { App, Typography } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import { ActionsDropdown } from '@/shared/components/ActionsDropdown';
import { ratesQueryKeys, useDeleteRate, useRestoreRate } from '@/features/agreements/hooks/useRates';
import { getErrorMessage } from '@/shared/utils/errors/getErrorMessage';
import { getMenuItems } from './getMenuItems';

const { Text } = Typography;

export const RateActionsDropdown = ({ rate, agreementId, planId, onEdit }) => {
  const { notification } = App.useApp();

  const queryClient = useQueryClient();
  const deleteRateMutation = useDeleteRate();
  const restoreRateMutation = useRestoreRate();

  const handleActivateRate = () => {
    restoreRateMutation.mutate({ agreementId, planId, rateId: rate.id }, {
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: ratesQueryKeys.list({ agreementId, planId }) });
        notification.success({
          message: <Text strong>Tasa activada</Text>,
          description: '¡La tasa se ha activado correctamente!',
        });
      },
      onError: (error) => {
        notification.error({
          message: <Text strong>Tasa no activada</Text>,
          description: getErrorMessage(error),
        });
      },
    });
  };

  const handleInactivateRate = () => {
    deleteRateMutation.mutate({ agreementId, planId, rateId: rate.id }, {
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: ratesQueryKeys.list({ agreementId, planId }) });
        notification.success({
          message: <Text strong>Tasa inactivada</Text>,
          description: '¡La tasa se ha inactivado correctamente!',
        });
      },
      onError: (error) => {
        notification.error({
          message: <Text strong>Tasa no inactivada</Text>,
          description: getErrorMessage(error),
        });
      },
    });
  };

  const handleEdit = () => {
    onEdit?.(rate);
  };

  const actions = {
    edit: {
      handler: handleEdit,
      loading: false,
    },
    activate: {
      handler: handleActivateRate,
      loading: restoreRateMutation.isPending,
    },
    inactivate: {
      handler: handleInactivateRate,
      loading: deleteRateMutation.isPending,
    },
  };

  const items = getMenuItems({ record: rate, actions });

  return <ActionsDropdown items={items} />;
};
